import { BreakPoints } from '@kanda-libs/ks-design-library';

import Mobile from './Mobile';
import Desktop from './Desktop';

import { Helmet } from '../../../components';

const ViewComponent = ({}) => (
  <>
    <Helmet title="Forgot Password" />
    <BreakPoints mobile={<Mobile />} desktop={<Desktop />} />
  </>
);

ViewComponent.displayName = 'ForgotPassword-Confirmation-view';

export default ViewComponent;
